
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"none","stroke":"none"},attrs:{"d":"M0 0h24v24H0z"}}),_c('circle',{staticStyle:{"fill":"#1a1a1a"},attrs:{"cx":"12.04","cy":"12","r":"10","transform":"rotate(-89.31 12.04 11.996)"}}),_c('path',{staticStyle:{"fill":"#2eb6aa"},attrs:{"d":"M12 7.18A4.82 4.82 0 007.22 12 4.82 4.82 0 0012 7.18z"}}),_c('path',{staticStyle:{"fill":"#2eb6aa"},attrs:{"d":"M12 2a10 10 0 000 20 10.25 10.25 0 002.34-.27.26.26 0 00.18-.32l-.54-2a.25.25 0 00-.3-.18 7.27 7.27 0 01-1.68.19 7.41 7.41 0 115.4-2.34.34.34 0 01-.24.1.35.35 0 01-.34-.36V12A4.82 4.82 0 0012 16.82a4.81 4.81 0 002.23-.55v.51a3 3 0 003 3 2.94 2.94 0 002-.83l.05-.06A10 10 0 0012 2z"}}),_c('path',{staticStyle:{"fill":"#2eb6aa"},attrs:{"d":"M16.86 12V7.43a.25.25 0 00-.25-.25h-2.09a.25.25 0 00-.25.25v.3A4.81 4.81 0 0012 7.18 4.82 4.82 0 0016.86 12zM7.22 12A4.82 4.82 0 0012 16.82 4.82 4.82 0 007.22 12z"}}),_c('g',{staticStyle:{"opacity":".3"}},[_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M2 12a9.93 9.93 0 00.21 2.06 10 10 0 003 .47 9.89 9.89 0 009.89-9.89 10.23 10.23 0 00-.25-2.23A10.33 10.33 0 0012 2 10 10 0 002 12z"}})])])
          )
        }
      }
    